export default __webpack_public_path__ + "static/media/star.e9eaf67c.svg";